import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import * as Accessa from 'accessa'
import { toFeaturePropsShape } from './ArchiveLayoutBlogs'

const useStyles = makeStyles(({ breakpoints }) => ({
  container: {
    [breakpoints.down('sm')]: {
      paddingLeft: '2.5rem',
      paddingRight: '2.5rem',
    },
  },
}))

const ArchiveLayoutCategories = ({ data }) => {
  const {
    allContentfulCategory: { nodes },
    contentfulArchive,
  } = data
  const { container } = useStyles()

  return (
    <Box pt={5} pb={5}>
      <Accessa.Headers.Mast
        title={get(contentfulArchive, 'hero.title')}
      />
      <Box mt={5}>
        <Container className={container}>
          <Accessa.Features.Field
            lists={toFeaturePropsShape(nodes)}
          />
        </Container>
      </Box>
    </Box>
  )
}

ArchiveLayoutCategories.propTypes = {
  data: PropTypes.shape({
    contentfulArchive: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      hero: PropTypes.object,
    }),

    allContentfulCategory: PropTypes.shape({
      // eslint-disable-next-line
      nodes: PropTypes.array,
    }),
  }).isRequired,
}

export default ArchiveLayoutCategories
